$('.translation__toggler').on('click', function() {
  $(this).toggleClass('active');
  $('.translation__content').slideToggle();
});

if($('.check-current-lang-en').length){
  $('.search-items option[value="900000000"]').text('No limit');
}
